export const SUPPLIERS_CONTAINER_DIV: React.CSSProperties = {
  paddingTop: '20px',
  paddingBottom: '50px',
}

export const PANEL_CONTAINER_DIV: React.CSSProperties = {
  padding: '30px',
  background: '#FFFFFF',
}

export const COLLAPSE_HEADING_DIV: React.CSSProperties = {
  paddingBottom: '12px',
  fontSize: '18px',
}

export const PANEL_HEADING_DIV: React.CSSProperties = {
  display: 'flex',
}

export const LEFT_CONTENT_CONTAINER_DIV: React.CSSProperties = {
  display: 'inline-flex',
}

export const SUPPLIER_TYPE_TEXT: React.CSSProperties = {
  marginRight: '16px',
}

export const RIGHT_CONTENT_CONTAINER_DIV: React.CSSProperties = {
  display: 'flex',
  flexGrow: '1',
  justifyContent: 'flex-end',
  marginRight: '24px',
}

export const ATTACHMENTS_CONTAINER_DIV: React.CSSProperties = {
  marginTop: '8px',
}

export const LINK_BUTTON: React.CSSProperties = {
  fontWeight: 600,
  padding: 'unset',
  color: '#1270B8',
}

export const NUMBER_OF_SUPPLIERS_CONTAINER: React.CSSProperties = {
  marginLeft: '16px',
  color: '#000000D9',
}

export const SUPPLIER_ATTACHMENTS_ICON: React.CSSProperties = {
  marginRight: '4px',
}

export const FILE_OUTLINED_ICON: React.CSSProperties = {
  marginRight: '6px',
}

// NOTE: the Antd collapse icon/arrow is positioned absolutely so the styles have to be overriden in the same way
const COLLAPSE_EXPAND_ICON: string = `
&
  .ant-collapse-icon-position-end
  > .ant-collapse-item
  > .ant-collapse-header
  .ant-collapse-arrow {
  /* Puts the icon all the way at the end, without it is too far in with the padding we apply on each row. */
  right: 0px;
}
`

// Used to override the styling on the last child of the expandable panel - ensures the icon on the end is in the correct place as the padding is removed on this row
const COLLAPSE_EXPAND_ICON_LAST_CHILD: string = `
.ant-collapse-item {
  &.collapse-last-child {
    .ant-collapse-header {
      padding-bottom: 0px;
    }
    .ant-collapse-arrow {
      transform: unset;
    }
  }
}
`

// Used to override styling when expanding of an expandable component is disabled
const DISABLE_EXPANDABLE: string = `
.ant-collapse-item {
  &.ant-collapse-item-disabled {
    & .ant-collapse-header {
      cursor: default;
      color: inherit;
    }
  }
}
`

export const STYLED_COLLAPSE_CONTAINER_TEMPLATE: string = `
  ${COLLAPSE_EXPAND_ICON}

  ${COLLAPSE_EXPAND_ICON_LAST_CHILD}

  ${DISABLE_EXPANDABLE}

  & .ant-collapse-header {
    padding-left: 0px;
    padding-right: 0px;
    border-radius: unset;
  }
  
  & .ant-collapse-item {
    border-radius: unset;
    border-bottom: 1px solid #f0f0f0;
  
    .ant-collapse-header {
      padding-left: 0px;
      padding-right: 0px;
      border-radius: unset;
    }
  }
  
  & .ant-collapse-content ant-collapse-content-active {
    .ant-collapse-content-box {
      padding-bottom: 32px;
    }
  }
`
